export default __webpack_public_path__ + "static/company-3-750a733bb0ec68583c8719d79bda9388.png";